// CHG-2450 (GAP-3b-ii-b) — v2 port of web/dashboard/src/lib/datetime-local.ts
// (v1 CHG-0684 / ITER-2605). Bridge between ISO 8601 timestamps from the API
// and the value format `<input type="datetime-local">` accepts.
//
// Browsers reject any value on a datetime-local input that is not in strict
// `YYYY-MM-DDTHH:MM` shape with no timezone — so binding a raw ISO string
// (e.g. `2026-05-06T20:46:00+06:00`) renders the input BLANK after a refresh
// (the v1 BUG-1059 / EventEdit prefill regression). These helpers do the
// conversion at the form-state boundary: isoToDateTimeLocal on ingress
// (prefill), dateTimeLocalToIso on egress (submit).
//
// Semantics: the input is interpreted in the BROWSER's local timezone, matching
// native `<input type="datetime-local">` behaviour (same wall-clock caveat as
// v1 DRIFT-208 — surfaced here for the future real DateTimeField primitive,
// DRIFT-910).

export function isoToDateTimeLocal(iso?: string | null): string {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  const pad = (n: number) => String(n).padStart(2, "0");
  return (
    `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}` +
    `T${pad(d.getHours())}:${pad(d.getMinutes())}`
  );
}

export function dateTimeLocalToIso(local?: string | null): string | null {
  if (!local) return null;
  const d = new Date(local);
  if (Number.isNaN(d.getTime())) return null;
  return d.toISOString();
}
